"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var core_2 = require("@21st-night/core");
var LoadingIndicator_1 = __importDefault(require("../../LoadingIndicator"));
var SlideUpTransition_1 = __importDefault(require("../../SlideUpTransition"));
var EditCardFormContainer_1 = __importDefault(require("../EditCardFormContainer"));
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        content: {
            position: 'relative',
        },
        loading: {
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    });
});
var EditCardDialog = function (_a) {
    var cardId = _a.cardId, userId = _a.userId, onCancel = _a.onCancel, onSuccess = _a.onSuccess, other = __rest(_a, ["cardId", "userId", "onCancel", "onSuccess"]);
    var classes = exports.useStyles();
    var _b = __read(core_2.useFetchCard(cardId, userId), 2), loading = _b[0], card = _b[1];
    return (react_1.default.createElement(core_1.Dialog, __assign({ fullScreen: true, TransitionComponent: SlideUpTransition_1.default, BackdropProps: {
            style: { backgroundColor: '#FFF' },
        } }, other),
        react_1.default.createElement(core_1.DialogContent, { className: classes.content },
            (loading || !card) && (react_1.default.createElement("div", { className: classes.loading },
                react_1.default.createElement(LoadingIndicator_1.default, { size: 36 }))),
            !loading && card && (react_1.default.createElement(core_2.CardFormProvider, { card: card },
                react_1.default.createElement(EditCardFormContainer_1.default, { onSuccess: onSuccess, onCancel: onCancel }))))));
};
exports.default = EditCardDialog;
//# sourceMappingURL=EditCardDialog.js.map